export default {
    // host:"wxtest.qungouda88.com",
    // host:"localhost:59190",
    // host:"mcouponapi.jointerest.cn/api2",
    // host:"mcouponapi.jointerest.cn",
    login_key:"app_login_user_18",
    debug:false,
    default_aid :1,
    app_params_key:"app_params_18"
};